import type { Node } from '@xyflow/react'
import { MessageCircle, PhoneIncoming, Workflow } from 'lucide-react'
import { FlowNodeTypes, type NodeDataBase, StartNodeTypes } from 'v2/pages/flow/types'
import { FlowTypes } from 'v2/types'
import { AI_AGENT_V29_LABEL } from '../utils/ai-agent-v29'

export const startNodeTitle: Partial<Record<FlowTypes, { title: string; icon: JSX.Element }>> = {
  [FlowTypes.api_request]: {
    title: 'Trigger an API Request',
    icon: <Workflow size={16} />,
  },
  [FlowTypes.incoming_call]: {
    title: 'When a customer calls',
    icon: <PhoneIncoming size={16} />,
  },
  [FlowTypes.incoming_chat]: {
    title: 'When a customer sends a message on Chat',
    icon: <MessageCircle size={16} />,
  },
}

export const sidebarTitle = (
  flowType: FlowTypes,
  selectedNode: Node<NodeDataBase<unknown>> | undefined,
) => {
  if (selectedNode?.type === FlowNodeTypes.ai_agent_v29)
    return { title: AI_AGENT_V29_LABEL, icon: null }
  if (selectedNode?.type !== FlowNodeTypes.start)
    return { title: selectedNode?.data.config.name ?? '', icon: null }
  return {
    title: startNodeTitle[flowType]?.title,
    icon: startNodeTitle[flowType]?.icon,
  }
}

function isStartNodeType(val: unknown): val is StartNodeTypes {
  return Object.values(StartNodeTypes).includes(val as StartNodeTypes)
}

export const showSidebar = (flowType: FlowTypes, selectedNodeType: FlowNodeTypes) =>
  (selectedNodeType && selectedNodeType !== FlowNodeTypes.start) || isStartNodeType(flowType)
